import template from './ticketViewImportantList.template.html';

export default {
  template,
  bindings: {
    items: '=',
    accounts: '=',
    onPin: '&',
    onToggle: '&',
    onShareClient: '&',
    onSharePartner: '&',
    onLabelsSelect: '&',
    onEdit: '&',
    onDelete: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdMedia, $mdDialog, listImportantService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.currentOrganization = null;
      ctrl.list = listImportantService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = function () {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.list.setData(ctrl.items);
        ctrl.onReady({ list: ctrl.list });
      };
      ctrl.itemPin = function ($event, item) {
        ctrl.onPin({ event: $event, item: item });
      };
      ctrl.itemToggle = function ($event, item) {
        if (item.docType.name === '__datum_job') {
          var _canBeCompleted = true;
          if (item && item.items && item.items.length) {
            var len = item.items.length;
            while (len--) {
              if (!item.items[len].isActive) {
                _canBeCompleted = false;
                break;
              }
            }
          }
          if (_canBeCompleted) {
            ctrl.onToggle({ item: item });
          } else {
            $mdDialog.show(
              $mdDialog
                .alert()
                .clickOutsideToClose(true)
                .title('Warning')
                .textContent('Not all sub-tasks have been completed.')
                .ariaLabel('Alert Dialog')
                .ok('Ok')
                .targetEvent($event)
            );
          }
        }
      };
      ctrl.itemShareClient = function ($event, item) {
        ctrl.onShareClient({ event: $event, item: item });
      };
      ctrl.itemSharePartner = function ($event, item) {
        ctrl.onSharePartner({ event: $event, item: item });
      };
      ctrl.itemLabelsSelect = function ($event, item) {
        ctrl.onLabelsSelect({ event: $event, item: item });
      };
      ctrl.itemEdit = function ($event, item) {
        ctrl.onEdit({ event: $event, item: item });
      };
      ctrl.itemDelete = function ($event, item) {
        ctrl.onDelete({ event: $event, item: item });
      };
      ctrl.getAccount = function (idAccount) {
        return _.find(ctrl.accounts, function (account) {
          return account.id === idAccount;
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.items && changes.items.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
